import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';

export const PRODUCT_SIMILAR_RECO_REQUEST = 'PRODUCT_SIMILAR_RECO_REQUEST';
export const PRODUCT_SIMILAR_RECO_SUCCESS = 'PRODUCT_SIMILAR_RECO_SUCCESS';
export const PRODUCT_SIMILAR_RECO_ERROR = 'PRODUCT_SIMILAR_RECO_ERROR';

export const PRODUCT_CROSS_VERTICAL_MULTI_REQUEST = 'PRODUCT_CROSS_VERTICAL_MULTI_REQUEST';
export const PRODUCT_CROSS_VERTICAL_MULTI_SUCCESS = 'PRODUCT_CROSS_VERTICAL_MULTI_SUCCESS';
export const PRODUCT_CROSS_VERTICAL_MULTI_ERROR = 'PRODUCT_CROSS_VERTICAL_MULTI_ERROR';

export const PRODUCT_BROWSING_HISTORY_RECO_REQUEST = 'PRODUCT_BROWSING_HISTORY_RECO_REQUEST';
export const PRODUCT_BROWSING_HISTORY_RECO_SUCCESS = 'PRODUCT_BROWSING_HISTORY_RECO_SUCCESS';
export const PRODUCT_BROWSING_HISTORY_RECO_ERROR = 'PRODUCT_BROWSING_HISTORY_RECO_ERROR';

function productRecoRequestAction(type) {
	return { type };
}

function productRecoSuccessAction(type, data) {
	return { type, data };
}

function productRecoErrorAction(type, error) {
	return { type, error };
}

function fetchRecoAction(requestContext, currentPid, REQUEST_ACTION, SUCCESS_ACTION, ERROR_ACTION) {
	return dispatch => {
		dispatch(productRecoRequestAction(REQUEST_ACTION));
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				headers,
				pathname: `/api${requestContext.url}`
			}),
			{ requestContext }
		).then(data =>
			dispatch(productRecoSuccessAction(SUCCESS_ACTION, Object.assign({}, data['RESPONSE'], { currentPid })), err =>
				dispatch(productRecoErrorAction(ERROR_ACTION, err))
			)
		);
	};
}

export function fetchSimilarRecoAction(requestContext, currentPid) {
	return fetchRecoAction(
		requestContext,
		currentPid,
		PRODUCT_SIMILAR_RECO_REQUEST,
		PRODUCT_SIMILAR_RECO_SUCCESS,
		PRODUCT_SIMILAR_RECO_ERROR
	);
}

export function fetchCrossVerticalMultiAction(requestContext, currentPid) {
	return fetchRecoAction(
		requestContext,
		currentPid,
		PRODUCT_CROSS_VERTICAL_MULTI_REQUEST,
		PRODUCT_CROSS_VERTICAL_MULTI_SUCCESS,
		PRODUCT_CROSS_VERTICAL_MULTI_ERROR
	);
}

export function fetchBrowsingHistoryRecoAction(requestContext, currentPid) {
	return fetchRecoAction(
		requestContext,
		currentPid,
		PRODUCT_BROWSING_HISTORY_RECO_REQUEST,
		PRODUCT_BROWSING_HISTORY_RECO_SUCCESS,
		PRODUCT_BROWSING_HISTORY_RECO_ERROR
	);
}
